import React from "react";
import ImageContainer from "./ImageContainer";
import { workImages } from "./data/images";
import { Button } from "@/components/ui/button";
import { scrollToSection } from "@/lib/utils";

const OurWorkOverlay: React.FC = () => {
  return (
    <>
      <div className="relative w-full pt-12 h-[800px]">
        {/* Central Content */}
        <div className="absolute inset-0 z-10 pointer-events-none">
          <div className="flex flex-col items-center justify-center h-full text-white">
            <h2 className="text-[50px] font-medium mb-6 tracking-wide">
              Our Work
            </h2>
          </div>
        </div>

        {/* Image Containers */}
        <div className="absolute left-1/2 -translate-x-1/2">
          <ImageContainer
            src={workImages[0].src}
            alt={workImages[0].alt}
            description={workImages[0].description}
            title={workImages[0].title}
          />
        </div>

        {/* Left Column Images */}
        <div className="absolute left-48 top-1/2 -translate-y-1/2 space-y-8">
          {[1, 2].map((index) => (
            <ImageContainer
              key={`left-${index}`}
              src={workImages[index].src}
              alt={workImages[index].alt}
              description={workImages[index].description}
              title={workImages[index].title}
            />
          ))}
        </div>

        {/* Right Column Images */}
        <div className="absolute right-48 top-1/2 -translate-y-1/2 space-y-8">
          {[3, 4].map((index) => (
            <ImageContainer
              key={`right-${index}`}
              src={workImages[index].src}
              alt={workImages[index].alt}
              title={workImages[index].title}
              description={workImages[index].description}
              position="ml-auto"
            />
          ))}
        </div>

        {/* Bottom Image */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <ImageContainer
            src={workImages[5].src}
            alt={workImages[5].alt}
            description={workImages[5].description}
            title={workImages[5].title}
          />
        </div>
      </div>
      <div className="absolute bottom-14 left-32 text-white">
        <p className="text-[28.5px] mb-4 w-[393px] leading-9">
          We Make Our Clients Shine in the Digital Space
        </p>
        <Button
          onClick={() => scrollToSection("contact-us")}
          className="bg-white hover:bg-primary-sky text-primary font-normal"
        >
          Contact Us
        </Button>
      </div>
    </>
  );
};

export default OurWorkOverlay;
